<div class="tw-py-[15px] align-center">
  <div class="flex-row form-group">
    <div class="row-entry">
      <label class="control-label pull-left mb-0 tw-min-w-[120px]"
        >Live Screenshot:</label
      >
      <div
        class="tw-w-full tw-flex tw-flex-row tw-items-center tw-justify-end tw-gap-2.5"
      >
        <span class="mr-auto" [shown]="screenshotState() === 'no-license'">
          <a href="" (click)="confirmLicensing()" [shown]="hasDisplayFullAccess"
            >License Required</a
          >
          <span [shown]="!hasDisplayFullAccess">License Required</span>
        </span>
        <span
          id="notActivated"
          [shown]="
            screenshotState() !== 'no-license' &&
            displayService.display.onlineStatus === 'not_activated'
          "
        >
          Not Activated
        </span>
        <div
          class="text-gray tw-pl-2.5 tw-text-right"
          [shown]="screenshotState() === 'screenshot-loaded'"
        >
          Last Updated {{ lastModified | date: 'd-MMM-yyyy h:mm a' }}
        </div>
        <!-- online -->
        <a
          [shown]="
            reloadScreenshotEnabled() &&
            displayService.display.onlineStatus !== 'not_activated'
          "
          id="btnUpdateScreenshot"
          class="tw-border-solid tw-border-gray-200 tw-rounded-full tw-px-[5px] tw-pt-[5px] tw-text-gray-700 tw-cursor-pointer"
          (click)="screenshotService.requestScreenshot()"
        >
          <mat-icon
            svgIcon="refresh"
            class="small dark"
            matTooltip="Refresh"
            matTooltipClass="menu-tooltip"
            matTooltipPosition="above"
          />
        </a>
        <!-- offline, unsupported, out of date, not-installed? -->
        <!-- show nothing -->
      </div>
    </div>
  </div>
  @if (screenshotState() !== 'screenshot-loaded') {
    <div class="display-screenshot-panel flex-col">
      <div class="display-screenshot tw-bg-gray-50 tw-shadow-lg">
        @if (!screenshotState()) {
          <div class="display-screenshot-info">
            <p class="text-gray">Screenshot not available.</p>
          </div>
        }
        @if (
          screenshotState() &&
          screenshotState() !== 'no-license' &&
          displayService.display.onlineStatus === 'not_activated'
        ) {
          <div class="display-screenshot-info">
            <p class="text-gray">Display is not activated.</p>
          </div>
        }
        @if (
          screenshotState() &&
          !(
            screenshotState() !== 'no-license' &&
            displayService.display.onlineStatus === 'not_activated'
          ) &&
          screenshotState() === 'not-supported'
        ) {
          <div class="display-screenshot-info">
            <p class="text-gray">
              This media player does not support screenshots.
            </p>
          </div>
        }
        @if (screenshotState() === 'no-license') {
          <div class="display-screenshot-info">
            <p class="text-gray">License Required</p>
          </div>
        }
        @if (screenshotState() === 'screenshot-error') {
          <div class="display-screenshot-info">
            <p class="text-gray">
              There was a problem requesting the screenshot.
            </p>
          </div>
        }
        @if (screenshotState() === 'loading') {
          <div class="display-screenshot-info">
            <div class="app-loading-dots">
              <i
                aria-label="Loading"
                class="fa fa-3x fa-spinner fa-spin fa-fw"
              ></i>
            </div>
          </div>
        }
      </div>
    </div>
  }
  <img
    class="img-screenshot"
    [rotate]="orientation()"
    [invert]="shouldRotate"
    [src]="screenshotUrl"
    [shown]="screenshotState() === 'screenshot-loaded'"
  />
</div>
